import { cn } from "@/lib/utils";

export interface SectionContainerProps extends React.HTMLAttributes<HTMLElement> {
  as?: "section" | "div" | "header" | "footer";
}

export function SectionContainer({
  className,
  as: Tag = "section",
  children,
  ...rest
}: SectionContainerProps) {
  return (
    <Tag
      className={cn("mx-auto w-full max-w-6xl px-4 py-16 sm:px-6 md:py-24", className)}
      {...rest}
    >
      {children}
    </Tag>
  );
}
